export const isFetching = (state: any) => {
    return state.isFetching;
}

export const allEntries = (state: any) => {
    return state.allEntries;
}
